import type { Currency, RecurrenceFrequency, TransactionType } from "./types";

export const transactionTypeLabels: Record<TransactionType, string> = {
  expense: "Expense",
  income: "Income",
  transfer: "Transfer",
  correction: "Correction",
};

// Singular period nouns; the UI pluralizes ("Every 2 weeks").
export const recurrenceFrequencyUnits: Record<RecurrenceFrequency, string> = {
  weekly: "week",
  monthly: "month",
  yearly: "year",
};

// Used until the group's currency list has loaded.
export const fallbackCurrencies: Currency[] = [
  { id: "EUR", code: "EUR", symbol: "€", name: "Euro", is_base: true, is_used: true },
];
